import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';
import './Chip.scss';

function ChipList({ chipList, onDelete }) {
  return chipList.map((data) => (
    <Chip key={data.key} className="chip" label={data.label} onDelete={onDelete(data)} />
  ));
}

ChipList.propTypes = {
  onDelete: PropTypes.func.isRequired,
  chipData: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default ChipList;
